module.exports = __webpack_public_path__ + "static/media/0331_IMG_LES_ENSEIGNES_PORTIONS_HERSE.298966c3.png";